<template>
  <MUIDrawer class="ui__scrollbar--transparent">
    <nav class="mui-list mui-navigation">
      <MUIListItem
        v-for="collection in systemCollections"
        :class="{
          'is-selected': selectedItem === `collection:${collection.key}`
        }"
        :key="collection.path"
        role="menuitem"
        :text="collection.name"
        @click.native="transitionTo(collection.path)">
        <i slot="graphic" class="material-icons" role="presentation">{{collection.icon}}</i>
      </MUIListItem>
      <MUIListSubtitle
        title="Collections"
        :action="{
          icon: 'add_circle_outline',
          fn: () => { openDialog('CollectionNewDialog') },
          title: 'Create collection...'
        }" />
      <MUIListItem
        v-for="collection in userCollections"
        :class="{
          'is-selected': selectedItem === `collection:${collection.key}`
        }"
        :key="collection.key"
        role="menuitem"
        :text="collection.name"
        @click.native="transitionTo(`/collections/${collection.key}`)">
        <i slot="graphic" class="material-icons" role="presentation">{{collection.icon || 'folder'}}</i>
      </MUIListItem>
      <template v-if="isAdminUser && $store.state.app.recentSearches.length > 0">
        <MUIListSubtitle title="Recent Searches" />
        <MUIListItem
          v-for="(search, index) in $store.state.app.recentSearches.slice(0, 3)"
          :class="{
            'is-selected': selectedItem === `search:${search}`
          }"
          :key="`${index}:${search}`"
          role="menuitem"
          :text="search"
          @click.native="transitionTo(`/search/${encodeURIComponent(search)}`)">
          <i slot="graphic" class="material-icons" role="presentation">search</i>
        </MUIListItem>
      </template>
      <div class="mui-list-divider"></div>
      <MUIListItem
        role="menuitem"
        text="Send feedback..."
        @click.native="openDialog('Feedback')">
        <i slot="graphic" class="material-icons" role="presentation">feedback</i>
      </MUIListItem>
      <MUIListItem
        role="menuitem"
        text="Preferences"
        @click.native="openDialog('PreferencesDialog')">
        <i slot="graphic" class="material-icons" role="presentation">gear</i>
      </MUIListItem>
      <MUIListItem
        role="menuitem"
        :text="`Latest updates (v${version})`"
        @click.native="followLink('https://headwayapp.co/cookmark-news')">
        <i slot="graphic" class="material-icons" role="presentation">notifications</i>
      </MUIListItem>
      <MUIListItem
        class="buy-me-a-coffee"
        role="menuitem"
        text="Buy us a coffee?"
        @click.native="followLink('https://buymeacoff.ee/luckystudios')">
        <i slot="graphic" class="material-icons" role="presentation">favorite</i>
      </MUIListItem>
      <div class="mui-list-divider"></div>
      <MUIListItem
        role="menuitem"
        text="r/cookmark on Reddit"
        @click.native="followLink('https://reddit.com/r/cookmark')">
        <i slot="graphic" class="material-icons" role="presentation">forum</i>
      </MUIListItem>
      <div class="mui-list-divider"></div>
      <MUIListItem
        role="menuitem"
        text="Log out"
        @click.native="logout()"><i slot="graphic" />
      </MUIListItem>
    </nav>
  </MUIDrawer>
</template>

<script>
import MUIDrawer from './MUIDrawer'
import MUIListItem from './MUIListItem'
import MUIListSubtitle from './MUIListSubtitle'
import config from '../config.json'
import { mapGetters } from 'vuex'
import firebase from '@firebase/app'
import '@firebase/auth'
import {
  SET_DRAWER_VISIBILITY,
  SET_TEMPORARY_VIEW_VISIBILITY
} from '../modules/mutation-types'

export default {
  components: {
    MUIDrawer,
    MUIListItem,
    MUIListSubtitle
  },
  computed: {
    ...mapGetters([
      'isAdminUser',
      'systemCollections',
      'userCollections'
    ])
  },
  data () {
    return {
      version: config.version,
      selectedItem: 'collection:libary',
      recentSearches: [{
        query: 'turkey'
      }]
    }
  },
  methods: {
    logout () {
      this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'hidden' })
      firebase.auth().signOut().then(() => {
        this.$track('account.signOut', {
          context: 'account',
          ability: 'signOut'
        })
        window.location.href = '/login'
      }, error => {
        console.log(error)
      })
    },
    openDialog (name) {
      this.$store.commit(SET_TEMPORARY_VIEW_VISIBILITY, { name })
      if (this.$store.state.device.sizeClass === 'compact') {
        this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'hidden' })
      }
    },
    followLink (url) {
      window.open(url, 'blank')
      this.$track('link.follow', {
        context: 'link',
        ability: 'follow',
        url
      })
    },
    transitionTo (path) {
      if (this.$store.state.device.sizeClass === 'compact') {
        this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'hidden' })
      }
      this.$router.currentRoute.path !== path && this.$router.push(path)
    }
  },
  watch: {
    '$route.params' () {
      if (this.$route.params.collectionKey) {
        this.selectedItem = `collection:${this.$route.params.collectionKey}`
      } else if (this.$route.params.query) {
        this.selectedItem = `search:${this.$route.params.query}`
      } else if (this.$route.path === '/') {
        this.selectedItem = `collection:library`
      }
    }
  }
}
</script>
<style lang="sass">
.mui-layout__drawer
  .mui-list-item
    &.buy-me-a-coffee
      color: #ffe200
      svg path
        fill: #ffe200
</style>



// WEBPACK FOOTER //
// src/components/Drawer.vue